import { render, staticRenderFns } from "./PlayerPendingAddDataInputRewindStoryToQuest.vue?vue&type=template&id=e4fe51f8&"
import script from "./PlayerPendingAddDataInputRewindStoryToQuest.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingAddDataInputRewindStoryToQuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports